$(function () {

    var input = document.querySelector(".js-form-phone");
    var inputModal = document.querySelector(".js-form-phone-modal");

    var maskList = $.masksSort($.masksLoad("_app/files/phone-codes.json"), ['#'], /[0-9]|#/, "mask");
    var maskOpts =  {
        inputmask: {
            definitions: {
                '#': {
                    validator: "[0-9]",
                    cardinality: 1
                }
            },
            showMaskOnHover: false,
            autoUnmask: true
        },
        match: /[0-9]/,
        replace: '#',
        list: maskList,
        listKey: "mask",
    };

    $('.js-mask').inputmasks(maskOpts);

    const initMask = function (element) {
        let iti = window.intlTelInput(element, {
            // allowDropdown: false,
            // autoHideDialCode: false,
            // autoPlaceholder: "off",
            // dropdownContainer: document.body,
            // excludeCountries: ["us"],
            // formatOnDisplay: false,
            // geoIpLookup: function(callback) {
            //   $.get("http://ipinfo.io", function() {}, "jsonp").always(function(resp) {
            //     var countryCode = (resp && resp.country) ? resp.country : "";
            //     callback(countryCode);
            //   });
            // },
            // hiddenInput: "full_number",
            initialCountry: 'am',
            // localizedCountries: { 'de': 'Deutschland' },
            // nationalMode: false,
            // onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
            // placeholderNumberType: "MOBILE",
            preferredCountries: ['am', 'ru'],
            //separateDialCode: true,
            utilsScript: "build/js/utils.js",
        });
        element.addEventListener("countrychange", function(e) {
            e.target.value = iti.getSelectedCountryData().dialCode;
            e.target.blur();
            e.target.focus();
        });
    };

    initMask(input);
    initMask(inputModal);

})
